let useGenerativeGlobal = false;

export const useGenerativeVoiceGlobal = () => {
  return useGenerativeGlobal;
}

export const setUseGenerativeVoiceGlobal = (useGenerative) => {
  useGenerativeGlobal = useGenerative;
}

export const TTS_ENGINE_TYPE = {
  standard: 'standard',
  generative: 'generative',
};

export const createRandomSpeechMarks = () => {
  const numAudioChars = 200; // Gives up to 30 seconds of random visemes
  const visemesChars = ['u', 't', 's', 'o', 'i', 'r', 'e', 'a'];
  const randomVisemes = [];

  for (let i = 0; i < numAudioChars; i++){
    randomVisemes.push({
      type: 'viseme',
      value: visemesChars[Math.floor(Math.random() * visemesChars.length)],
      time: (i * 150)
    });
  }

  return [
    {
      words: [
        {
          type: 'word',
          visemes: randomVisemes
        }
      ]
    }
  ];
}

export const stripProsodyTags = (input) => {
  if (!input) return;

  // Regular expression to match the opening and closing <prosody> tags
  const prosodyTagRegex = /<prosody[^>]*>|<\/prosody>/gi;

  // Replace the <prosody> tags with a space
  return input.replace(prosodyTagRegex, " ");
}

export const stripEmphasisTags = (input) => {
  if (!input) return;

  // Regular expression to match the opening and closing <emphasis> tags
  const emphasisTagRegex = /<emphasis[^>]*>|<\/emphasis>/gi;
  
  // Replace the <emphasis> tags with a space
  return input.replace(emphasisTagRegex, ' ');
}